import { connect } from 'react-redux'

const mapStateToProps = (state) => {
    return {
        hallInfoData: state?.pages?.hall?.movie?.hallInfoData?.cinemaHallsEntries?.[0],
    }
}

const hocHallDetails = (InnerComponent) => connect(mapStateToProps)(InnerComponent)

export default hocHallDetails
